<template>
  <div>
    <v-card>
      <v-card-title class="pb-0">
        <v-select
          v-model="localData"
          outlined
          :items="items"
          :readonly="readonly"
          :disabled="disabled"
          item-text="name"
          item-value="id"
          :label="name"
        ></v-select>
      </v-card-title>
      <v-card-text>
        <v-card outlined>
          <v-list dense class="py-0">
            <template v-for="(el, key) in items">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ el.name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="items.length - 1 !== key" />
            </template>
          </v-list>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'Select',

  model: {
    prop: 'data'
  },

  props: {
    data: {
      type: Array,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localData: null
  }),

  computed: {},

  watch: {
    localData: {
      deep: true,
      handler: 'setTranslation'
    },
    data: {
      deep: true,
      handler() {
        if (JSON.stringify(this.data) === JSON.stringify(this.localData)) {
          return;
        }
        this.setData();
      }
    }
  },

  created() {},

  methods: {
    setData() {
      this.localData = cloneDeep(this.data);
    },
    setTranslation() {
      this.$emit('input', Object.assign([], this.localData));
    }
  }
};
</script>
